
import {IonPage, IonContent, IonList,IonNote, IonItem, IonLabel,IonButton, IonListHeader} from '@ionic/vue'
import TaskItem from "@/components/TaskItem.vue";
import {defineComponent} from "vue";
import {useStore} from "@/store/store";
import {useI18n} from "vue-i18n";
import firebase from "firebase";
import {Review, Task, TaskState, TaskUtils} from "@/store/state";
import {useRouter} from "vue-router";
export default defineComponent({
  components: {
    IonListHeader,
    IonItem,
    IonLabel,
    TaskItem,
    IonPage,
    IonContent,
    IonList,IonNote, IonButton
  },
  name: "Reviews",
  computed:{

  },
  data(){
    const selected: string[] = []
    return {
      selected
    }
  },
  filters:{

  },
  methods:{
    formatReviewDate(v: any){
      const d = TaskUtils.asDate(v)
      return d.toLocaleDateString('de-de');
    },
    notReviewedAndFinishedTasks(tasks: Task[]): Task[]{
      console.log("tasks",tasks);
      return tasks.filter((t: Task) => t.state==TaskState.Done && !t.reviews.length )
    },
    createReview(tasks: string[]){
      this.router.push({name: 'NewReview',params:{tasks:tasks.join(',')}})
    },
    editReviewReview(review: string){
      this.router.push({name: 'EditReview',params:{reviewId:review}})
    },
    tasks(review: Review){
      const tasks: string = this.store.state.tasks.filter((t: Task) => review.tasks.includes(t.id)).map((t: Task)=>t.name).join(', ');
      if(tasks) return 'Aufgaben: '+tasks;
      return 'Keine verknüpften Aufgaben'
    }

  },
  setup(){
    const store = useStore()
    const router = useRouter()
    const t = useI18n()
    return {
      router,
      store,
      t
    }
  }
})
